import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AdminCommonRepository from "src/repository/Admin/AdminCommonRepository";

export const getRoleList = createAsyncThunk('get_admin_role_list', async () => {
    return await new AdminCommonRepository().getRoleList()
});

export const getOrgList = createAsyncThunk('get_org_list', async () => {
    return await new AdminCommonRepository().getOrganizationList()
});

const slice = createSlice({
    name: "AdminCommon",
    initialState: {
        roleList: [],
        orgList: [],
    },
    reducers: {

    },
    extraReducers: {
        [getRoleList.fulfilled]: (state, { payload }) => {
            state.roleList = payload;
        },
        [getOrgList.fulfilled]: (state, { payload }) => {
            state.orgList = payload;
        },

    },
});



export let { } = slice.actions;

export default slice.reducer;
